import { formatHeaderName } from "./dataViewUtils";

export const downloadDataViewCsv = ({
  rows = [],
  headers = [],
  datasetName = 'data',
  currentPage = 1,
}) => {
  if (!rows.length || !headers.length) {
    return;
  }

  const csvHeader = headers.map((header) => `"${formatHeaderName(header)}"`).join(',');
  const csvRows = rows.map((record) =>
    headers
      .map((header) => {
        let value = record[header];

        if (value === null || value === undefined || value === '') {
          return '';
        }

        if (typeof value === 'object') {
          value = JSON.stringify(value);
        }

        return `"${String(value).replace(/"/g, '""')}"`;
      })
      .join(',')
  );

  const csvContent = [csvHeader, ...csvRows].join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  const normalizedDatasetName = datasetName.toLowerCase().replace(/\s+/g, '_');

  link.setAttribute('href', url);
  link.setAttribute(
    'download',
    `${normalizedDatasetName}_page_${currentPage}_${new Date()
      .toISOString()
      .split('T')[0]}.csv`
  );
  link.style.visibility = 'hidden';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
